import League from "@Enums/Leagues";
import { getLeagueColor } from "@Helpers/league-utils";
import { getMedalBackgroundColor } from "@Helpers/medal-utils";
import { useTheme } from "@mui/material";
import BaseAvatar, { IBaseAvatar } from "./base-avatar";

interface IBybAvatar extends IBaseAvatar {
  league?: League;
  size?: number;
}

const BybAvatar = ({ league, size, user, ...props }: IBybAvatar) => {
  const theme = useTheme();

  return (
    <BaseAvatar
      user={user}
      {...props}  
      sx={{
        ...(size && {
          width: theme.spacing(size),
          height: theme.spacing(size),
          fontSize: theme.spacing(size / 3),
        }),
        ...(!!league && {
          border: "4px solid transparent",
          borderRadius: "50em",
          background: `${getMedalBackgroundColor(league, theme)} padding-box, ${getLeagueColor(league, theme)} border-box`,
        }),
      }}
    />
  );
};

export default BybAvatar;
